import LogCallTab from './logCallTab.view';

export default LogCallTab;
